import React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { ColumnVersion } from '../types'
import { formatDate } from '../utils/formatters'

interface VersionEntryProps {
    version: ColumnVersion
    onOpen?: () => void
    onCompare?: () => void
}

const VersionEntry = ({ version, onOpen, onCompare }: VersionEntryProps) => {
    const formattedDate = formatDate(version.createdAt)
    const userName = version.createdBy?.name || 'Unknown user'

    return (
        <Stack
            direction="row"
            alignItems="flex-start"
            justifyContent="space-between"
            sx={{
                py: 2,
                borderBottom: '1px solid',
                borderColor: 'figma.grayscale.stroke',
            }}
        >
            <Stack gap={0.5}>
                <Typography variant="14x600" color="figma.grayscale.textHier1">
                    Version: {version.versionNumber}
                </Typography>
                <Typography variant="14x400" color="figma.grayscale.textHier2">
                    Saved: {formattedDate}, by {userName}
                </Typography>
                {version.note && (
                    <Typography variant="12x400" color="figma.grayscale.textHier3" fontStyle="italic">
                        {version.note}
                    </Typography>
                )}
            </Stack>

            <Stack direction="row" gap={1}>
                <Button
                    variant="text"
                    size="small"
                    onClick={onOpen}
                    disabled={!onOpen}
                    sx={{
                        color: 'figma.primary',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        fontSize: '12px',
                        minWidth: 'auto',
                        px: 1,
                    }}
                >
                    Open
                </Button>
                <Button
                    variant="text"
                    size="small"
                    onClick={onCompare}
                    disabled={!onCompare}
                    sx={{
                        color: 'figma.primary',
                        textTransform: 'uppercase',
                        fontWeight: 600,
                        fontSize: '12px',
                        minWidth: 'auto',
                        px: 1,
                    }}
                >
                    Compare
                </Button>
            </Stack>
        </Stack>
    )
}

export default VersionEntry
